// extracted by mini-css-extract-plugin
export default {"contenedor":"modelos_contenedor__JXOWG","modelos":"modelos_modelos__aI71Z"};